import { Component, OnInit, HostListener, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { ViewportScroller } from '@angular/common';
import { trigger } from '@angular/animations';

declare const $: any //for jquery $, use this for slider slick

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.css']
})
export class SectionComponent implements OnInit {

  quote_result:boolean = false;
  title:string = 'Volumetric Calculator';
  visible:boolean = false;
  varWeight:number = 0.0;

  // Forms
  inputSender:any= "";
  inputRecipient:any= "";
  inputWeight:any = "";
  inputType:any='P'; //default checked Parcel
  inputWidth:any = "";
  inputLength:any = "";
  inputHeight:any = "";

  // form alert class binder 
  isInvalid:boolean = true;
  isInvalid2:boolean = true;
  isInvalid3:boolean = true;
  isInvalid4:boolean = true;

  isValid:boolean = true;
  isValid2:boolean = true;
  isValid3:boolean = true;
  isValid4:boolean = true;

  itemType:any;

  origincity:any;
  destinationcity:any;

  // quotation 
  deliverycharge:number = 0.00;
  price:number = 0.00;
  surcharge:number = 0.00;
  servicetax:number;

  //quotation extra display
  displayWeight:number;
  displaySender:number;
  displayRecipient:number;

  //track
  trackerList:any;
  trackerListRecon:any = {};
  trackCode:any = "";
  trackerDisplay:boolean = false;
  quoteDisplay:boolean = false;
  imageTracker:string = "./assets/image/TRACKING/BOOKED.png";
  trackerArr: any;
  elementId: string="";
  
  toggleStatus:any="DEFAULT";

  //part3 Image
  hoverImage:any;
 
  constructor(
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private router: Router,
    private viewportScroller: ViewportScroller
  ) { }

  async ngOnInit() {

    $(document).ready(function() {
        $('.slider').slick({
          centerMode: true,
          centerPadding: '23vw',
          slidesToShow: 1,
          speed: 500,
          index: 2,
          arrows:false,
          focusOnSelect:true
        });
        }
      );

    // Options for the observer (which mutations to observe)
    const config = { 
        attributes: true, 
        attributeFilter: ["class"]
    };
    
    // Callback function to execute when mutations are observed
    const callback = (mutationList) => {
      for (const mutation of mutationList) {
        const el= mutation.target;
        if(el.classList.contains("slick-center")){
            this.changeSlideContent();
        }
      }
    };
    
    // Create an observer instance linked to the callback function
    const observer:MutationObserver = new MutationObserver(callback);
    
    document.querySelectorAll('.customSlide').forEach(function(node) {
        observer.observe(node,config);
    })
    

    } 
    
    clicked(choice:String){

      if(choice=="track"){
        let tabcontent1 = document.getElementById("trackShipment");
        tabcontent1.style.display="block";
        let tabcontent1a = document.getElementById("trackShipmentButton");
        tabcontent1a.style.color="white";

        let tabcontent2 = document.getElementById("getAQuote");
        tabcontent2.style.display="none";
        let tabcontent2a = document.getElementById("getAQuoteButton");
        tabcontent2a.style.color="black";

        let transform = document.getElementById("switch");
        transform.style.transform="translateX(0px)";
        transform.style.transition="0.1s";

        let image1 = document.getElementById("locationImageContainer");
        image1.style.display="block";

        let image2 = document.getElementById("imageContainer");
        image2.style.display="none";

        this.quoteDisplay = false;

        this.trackCode="";
        this.inputSender="";
        this.inputRecipient="";
        this.inputWeight="";
        this.inputWidth="";
        this.inputLength="";
        this.inputHeight="";
      }
      else{
        let tabcontent1 = document.getElementById("trackShipment");
        tabcontent1.style.display="none";
        let tabcontent1a = document.getElementById("trackShipmentButton");
        tabcontent1a.style.color="black";

        let tabcontent2 = document.getElementById("getAQuote");
        tabcontent2.style.display="block";
        let tabcontent2a = document.getElementById("getAQuoteButton");
        tabcontent2a.style.color="white";

        let transform = document.getElementById("switch");
        transform.style.transform="translateX(100%)";
        transform.style.transition="0.1s";

        let image1 = document.getElementById("locationImageContainer");
        image1.style.display="none";

        let image2 = document.getElementById("imageContainer");
        image2.style.display="block";

        let defaultCheckParcel = document.getElementById("parcel");
        defaultCheckParcel.style.backgroundColor="#2196F3";
        defaultCheckParcel.style.border="none";
        
        this.trackerDisplay = false;

        this.trackCode="";
        this.inputSender="";
        this.inputRecipient="";
        this.inputWeight="";
        this.inputWidth="";
        this.inputLength="";
        this.inputHeight="";
      }
    }

    changeImage(type:String){
      if(type=="parcel"){
        let parcelImage = document.getElementById("parcelImage");
        parcelImage.style.display="block";

        let documentImage = document.getElementById("documentImage");
        documentImage.style.display="none";
      }
      else{
        let parcelImage = document.getElementById("parcelImage");
        parcelImage.style.display="none";

        let documentImage = document.getElementById("documentImage");
        documentImage.style.display="block";
      }
    }

    service(type:String){
      var serviceActive;
      var serviceImage;
      var serviceDescription;
      var service1,service2,service3,service4,service5;

      service1 = document.getElementById("express-service");
      service1.src="../../assets/image/OUR PRODUCTS/EXPRESS DEFAULT.png"
      service2 = document.getElementById("valuePack-service");
      service2.src="../../assets/image/OUR PRODUCTS/VALUEPACK DEFAULT.png"
      service3 = document.getElementById("premium-service");
      service3.src="../../assets/image/OUR PRODUCTS/PREMIUM DEFAULT.png"
      service4 = document.getElementById("premiumBox-service");
      service4.src="../../assets/image/OUR PRODUCTS/PREMIUMBOX DEFAULT.png"
      service5 = document.getElementById("freshBox-service");
      service5.src="../../assets/image/OUR PRODUCTS/FRESHBOX DEFAULT.png"

      switch(type){
        case "express":
          serviceActive = document.getElementById("express-service");
          serviceActive.src="../../assets/image/OUR PRODUCTS/EXPRESS TOGGLE.png"
          serviceImage= document.getElementById("Service-Express");
          serviceDescription=document.getElementById("serviceDescription1");
          break;
        case "valuePack":
          serviceActive = document.getElementById("valuePack-service");
          serviceActive.src="../../assets/image/OUR PRODUCTS/VALUEPACK TOGGLE.png"
          serviceImage= document.getElementById("Service-Valuepack");
          serviceDescription=document.getElementById("serviceDescription2");
          break;
        case "premium":
          serviceActive = document.getElementById("premium-service");
          serviceActive.src="../../assets/image/OUR PRODUCTS/PREMIUM TOGGLE.png"
          serviceImage= document.getElementById("Service-Premium");
          serviceDescription=document.getElementById("serviceDescription3");
          break;
        case "premiumBox":
          serviceActive = document.getElementById("premiumBox-service");
          serviceActive.src="../../assets/image/OUR PRODUCTS/PREMIUMBOX TOGGLE.png"
          serviceImage= document.getElementById("Service-PremiumBox");
          serviceDescription=document.getElementById("serviceDescription4");
          break;
        case "freshBox":
          serviceActive = document.getElementById("freshBox-service");
          serviceActive.src="../../assets/image/OUR PRODUCTS/FRESHBOX TOGGLE.png"
          serviceImage= document.getElementById("Service-FreshBox");
          serviceDescription=document.getElementById("serviceDescription5");
          break;
      }

      let serviceImageList=document.getElementById("serviceImageList");
      var otherImage;

      let serviceDescriptionList=document.getElementById("serviceDescriptionList");
      var otherDescription;

      for(let i=0;i<5;i++){
        otherImage=serviceImageList.children[i] as HTMLElement;
        otherImage.style.display="none";

        otherDescription=serviceDescriptionList.children[i] as HTMLElement;
        otherDescription.style.display="none";
        
      }
         
      serviceImage.style.display="block"; 
      serviceDescription.style.display="block";
      
    }

    setBool(){
      this.quote_result = !this.quote_result;
      this.inputWeight = null;
    }

    getVolume(){

        let answers:any = (this.inputWidth * this.inputLength * this.inputHeight )/6000;

        answers = answers.toFixed(1)
        
        this.inputWeight = answers

        // reset value
        this.inputWidth = null;
        this.inputLength = null;
        this.inputHeight = null;

        // let elem = document.getElementById('calculate');

        // setTimeout(function () {
        //     let evt = new MouseEvent('click', {
        //             bubbles: true,
        //             cancelable: true,
        //             view: window
        //         });

        //     elem.dispatchEvent(evt);
        // }, 350);
    }

    quoteSubmit(quoteForm){
        
    this.displaySender=this.inputSender
    this.displayRecipient=this.inputRecipient

      this.visible = true;

      console.log('form data: ', quoteForm);
      console.log('data: ', quoteForm.value)

      if(this.inputType == 'D'){
          this.itemType = 'Document'
      }else{
          this.itemType = 'Parcel'
      }

      console.log(this.inputHeight)
      console.log(this.inputLength)
      console.log(this.inputWidth)

      if(this.inputHeight!=0&&this.inputLength!=0&&this.inputWidth!=0){
        console.log(this.inputWeight)
        let answers:any = (this.inputWidth * this.inputLength * this.inputHeight )/6000;

        answers = answers.toFixed(1)
        
        if(answers>this.inputWeight){
            this.inputWeight = answers  //take the heavier value for weight 
        }

        // reset value
        this.inputWidth = null;
        this.inputLength = null;
        this.inputHeight = null;
      }

      if(this.inputWeight==0){
        this.inputWeight=0; //here is because the default value is null/0 but if dont assign here then will become null value display
      }

      console.log(this.inputWeight)
      this.apiService.getQuotation(this.inputSender, this.inputRecipient, this.inputWeight, this.inputType).subscribe((res: any) => {

        this.quoteDisplay = true
        
          if(res.servicetype =="ODA"){
              this.surcharge = 21.20;
          }

          
          this.displayWeight=this.inputWeight
          

          this.price = res.price
          this.origincity = res.origincity
          this.destinationcity = res.destinationcity

          this.deliverycharge = (this.price - this.surcharge);
          this.servicetax = (this.price - this.surcharge - this.deliverycharge);

          this.setBool();

      }, error => {
          Swal.fire("Oops...", "Error : Failed!", "error")
      }) 

      setTimeout(() => {;
          this.visible = false
      }, 1500);

      this.quoteDisplay=true;

    //   let quoteResult = document.getElementById("quoteResult");
    //   quoteResult.style.display="flex";
      
console.log(this.inputSender);
console.log(this.inputRecipient);
console.log(this.inputWeight);
console.log(this.inputType);
this.inputSender = "";
this.inputRecipient = "";
    }

    getTrackerData(elementId:any): void{    

        this.visible = true;
        const trackerStr = this.trackCode
            
        var str_array = trackerStr.split(',');

        const dataArr = []

        for(var i = 0; i < str_array.length; i++) {
            // Trim the excess whitespace.
            str_array[i] = str_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
            // Add additional code here, such as:
            // console.log('tracker string: ' + str_array[i])

            dataArr.push(str_array[i])
        }


        let data = { 
            "SearchType" : "WayBillNumber",
            "WayBillNumber" : dataArr 
        }

        this.apiService.postTracker(data).subscribe((res: any) => {
            
            this.trackerDisplay = true

            // this.trackerArr = res
            this.trackerList = res
            console.log('this.trackerList', this.trackerList)
            let trackerData = []

            this.trackerList[0].forEach(element => {
                //console.log('element', element)
                
                switch(element.StatusCode){
                    case 'WB004':
                        var des = element.Description;
                        des = des.replace("Manifest Out Scan completed at Pickup branch","Checked Out and Departed to Branch");
                        element.Description = des.split("on")[0];
                        break;
                    case 'WB009':
                        var des = element.Description;
                        des = des.replace("Manifest Out Scan completed at Pickup Hub","Checked Out and Departed to Hub");
                        element.Description = des.split("on")[0];
                        break;
                    case 'WB013':
                        var des = element.Description;
                        des = des.replace("Manifest Out Scan completed","Transit Cage Out");
                        element.Description = des.split("on")[0];
                        break;
                    case 'WB017':
                        var des = element.Description;
                        des = des.replace("Ready for Delivery","Parcel has Arrived" );
                        element.Description = des;
                        break;
                    case 'WB005': case 'WB007': case 'WB010': case 'WB014':
                    case 'WB016': case 'WB019': case 'WB022': case 'WB023':
                    case 'WB025': case 'WB026':
                        delete element.Description;
                        delete element.LastModifiedDate;
                        delete element.LastModifiedOn;
                        delete element.LastModifiedTime;
                        delete element.NextLocation;
                        delete element.Status;
                        delete element.StatusCode;
                        delete element.TransitLocation;
                        delete element.UndelCode;
                        delete element.UndelReason;
                        delete element.WayBillNumber;  
                        break;
                    default:
                        var des = element.Description;
                        element.Description = des.split("on")[0];
                        break;               
                }

                if(element.StatusCode == "WB020"){

                    switch (element.UndelCode) {
                        case 'V001':
                            element.Description = "UnDelivered (Consignee not available)"
                            break;
                        case 'V002':
                            element.Description = "UnDelivered (Incomplete Address)"
                            break;
                        case 'V003':
                            element.Description = "UnDelivered (Return To Shipper (RTS))"
                            break;
                        case 'V004':
                            element.Description = "UnDelivered (Bad Weather)"
                            break;    
                        case 'V005':
                            element.Description = "UnDelivered (Office Collection)"
                            break; 
                        case 'V006':
                            element.Description = "UnDelivered (Unable to Complete)"
                            break; 
                        case 'V007':
                            element.Description = "UnDelivered (Short Piece(s))"
                            break;    
                        case 'V008':
                            element.Description = "UnDelivered (ODA Delivery - Delivery on selected days)"
                            break; 
                        case 'V009':
                            element.Description = "UnDelivered (Closed on arrival)"
                            break; 
                        case 'V010':
                            element.Description = "UnDelivered (No show at destination)"
                            break;    
                        case 'V011':
                            element.Description = "UnDelivered (Return to origin)"
                            break; 
                        case 'V012':
                            element.Description = "UnDelivered (Suspected lost)"
                            break; 
                        case 'V013':
                            element.Description = "UnDelivered (Suspected Damage)"
                            break;    
                        case 'V014':
                            element.Description = "UnDelivered (Misrouted)"
                            break; 
                        case 'V015':
                            element.Description = "UnDelivered (Wrong IC/Passport no.)"
                            break; 
                        case 'V016':
                            element.Description = "UnDelivered (COD amount not ready)"
                            break; 
                        case 'V017':
                            element.Description = "UnDelivered (Consignee Shifted)"
                            break; 
                        case 'V018':
                            element.Description = "UnDelivered (Unable to contact consignee)"
                            break;    
                        case 'V019':
                            element.Description = "UnDelivered (Cancel order)"
                            break; 
                        case 'V020':
                            element.Description = "UnDelivered (Consignee refused to accept)"
                            break; 
                        case 'V021':
                            element.Description = "UnDelivered (Change delivery date)"
                            break;    
                        case 'V022':
                            element.Description = "UnDelivered (Restrictions delivery areas)"
                            break; 
                        case 'V023':
                            element.Description = "UnDelivered (Business closed down)"
                            break; 
                        default:
                            break;
                    }
                }

                
            });

            this.trackerList.forEach(trackerID => {

                // check 1st object since it is the latest status 
                let trackingstatus = trackerID[0]

                console.log('tracking status: ', trackingstatus)

                switch (trackingstatus.Status) {
                    case "Delivered":
                        this.imageTracker="./assets/image/TRACKING/DELIVERED.png"
                        break;
                    case "Out for Delivery":
                        this.imageTracker="./assets/image/TRACKING/OFD.png"
                        break;
                    case "Order Placed":
                        this.imageTracker="./assets/image/TRACKING/BOOKED.png"
                        break;
                    default:
                        // all other status will be in transit status 
                        this.imageTracker="./assets/image/TRACKING/INTRANSIT.png"
                        break;
                }

                trackerData.push({"data" : trackerID, "image" : this.imageTracker})
        
            });
            
            this.trackerListRecon = trackerData
            console.log('json data: ', this.trackerListRecon)

            var newArray :any = {};
            newArray = this.trackerListRecon[0].data.filter(value => Object.keys(value).length !== 0 );
            this.trackerListRecon[0].data = newArray
            console.log('json data2 : ', this.trackerListRecon)
            this.trackCode = ""
            window.history.replaceState(null, document.title, "/tracker")

        }, error => {
            // Swal.fire("Backend Error!", "Error : <small style='color: red; font-style: italic;'>" + error.error.message + "</small>", "error")

            this.trackerDisplay = false;

            // looking for ShipmentRef

            let data = { 
                "SearchType" : "ShipmentRef",
                "ShipmentRef" : dataArr 
            }

            this.apiService.postTracker(data).subscribe((res: any) => {
                // console.log('raw resp:', res)
        
                this.trackerDisplay = true
        
                this.trackerList = res

                console.log("Track:" + this.trackerList)
        
                let trackerData = []

                this.trackerList[0].forEach(element => {
                    //console.log('element', element)
        
                    if(element.StatusCode == "WB020"){
        
                        switch (element.UndelCode) {
                            case 'V001':
                                element.Description = "UnDelivered (Consignee not available)"
                                break;
                            case 'V002':
                                element.Description = "UnDelivered (Incomplete Address)"
                                break;
                            case 'V003':
                                element.Description = "UnDelivered (Return To Shipper (RTS))"
                                break;
                            case 'V004':
                                element.Description = "UnDelivered (Bad Weather)"
                                break;    
                            case 'V005':
                                element.Description = "UnDelivered (Office Collection)"
                                break; 
                            case 'V006':
                                element.Description = "UnDelivered (Unable to Complete)"
                                break; 
                            case 'V007':
                                element.Description = "UnDelivered (Short Piece(s))"
                                break;    
                            case 'V008':
                                element.Description = "UnDelivered (ODA Delivery - Delivery on selected days)"
                                break; 
                            case 'V009':
                                element.Description = "UnDelivered (Closed on arrival)"
                                break; 
                            case 'V010':
                                element.Description = "UnDelivered (No show at destination)"
                                break;    
                            case 'V011':
                                element.Description = "UnDelivered (Return to origin)"
                                break; 
                            case 'V012':
                                element.Description = "UnDelivered (Suspected lost)"
                                break; 
                            case 'V013':
                                element.Description = "UnDelivered (Suspected Damage)"
                                break;    
                            case 'V014':
                                element.Description = "UnDelivered (Misrouted)"
                                break; 
                            case 'V015':
                                element.Description = "UnDelivered (Wrong IC/Passport no.)"
                                break; 
                            case 'V016':
                                element.Description = "UnDelivered (COD amount not ready)"
                                break; 
                            case 'V017':
                                element.Description = "UnDelivered (Consignee Shifted)"
                                break; 
                            case 'V018':
                                element.Description = "UnDelivered (Unable to contact consignee)"
                                break;    
                            case 'V019':
                                element.Description = "UnDelivered (Cancel order)"
                                break; 
                            case 'V020':
                                element.Description = "UnDelivered (Consignee refused to accept)"
                                break; 
                            case 'V021':
                                element.Description = "UnDelivered (Change delivery date)"
                                break;    
                            case 'V022':
                                element.Description = "UnDelivered (Restrictions delivery areas)"
                                break; 
                            case 'V023':
                                element.Description = "UnDelivered (Business closed down)"
                                break; 
                            default:
                                break;
                        }
                    }
                });
        
                this.trackerList.forEach(trackerID => {
        
                    // check 1st object since it is the latest status 
                    let trackingstatus = trackerID[0]
        
                    // console.log('tracking status: ', trackingstatus)
        
                    switch (trackingstatus.Status) {
                        case "Delivered":
                            this.imageTracker="./assets/image/TRACKING/DELIVERED.png"
                            break;
                        case "Out for Delivery":
                            this.imageTracker="./assets/image/TRACKING/OFD.png"
                            break;
                        case "Order Placed":
                            this.imageTracker="./assets/image/TRACKING/BOOKED.png"
                            break;
                        default:
                            // all other status will be in transit status 
                            this.imageTracker="./assets/image/TRACKING/INTRANSIT.png"
                            break;
                    }
        
                    trackerData.push({"data" : trackerID, "image" : this.imageTracker})
            
                });
        
                this.trackerListRecon = trackerData
                // console.log('json data: ', this.trackerListRecon)

                var newArray :any = {};
                newArray = this.trackerListRecon[0].data.filter(value => Object.keys(value).length !== 0 );
                this.trackerListRecon[0].data = newArray

                this.trackCode = ""
                window.history.replaceState(null, document.title, "/tracker")
        
            }, error => {
                Swal.fire("Not Found!", "Error : <small style='color: red; font-style: italic;'>Item Not Found!</small>", "error")
                this.trackerDisplay = false
                
            })
            
        }) 

        setTimeout(() => {;
            this.visible = false
            this.viewportScroller.scrollToAnchor(elementId);
        }, 1500);

        // let trackerResult = document.getElementById("trackerResult");
        // trackerResult.style.display="block";

        this.trackerDisplay = true;
    }

    goToPortal(){
        window.open('https://www.lineclearexpressonline.com/#/auth/register');
    }

    goToRateChart(){
        window.open('https://lineclearexpress.com/doc/walk_in_rate.pdf');
    }

    slideChange(){
        console.log("12");
        var slideText;
        var slideImage;
        var slide1,slide2,slide3,slide4,slide5;
    
        slide1=document.getElementById("slideImage1");
        slide1.src="../../assets/image/OUR PRODUCTS (MOBILE)/EXPRESS BLUR.png";
    
        slide2=document.getElementById("slideImage2");
        slide2.src="../../assets/image/OUR PRODUCTS (MOBILE)/VALUEPACK BLUR.png";
        
        slide3=document.getElementById("slideImage3");
        slide3.src="../../assets/image/OUR PRODUCTS (MOBILE)/PREMIUM BLUR.png";
        
        slide4=document.getElementById("slideImage4");
        slide4.src="../../assets/image/OUR PRODUCTS (MOBILE)/PREMIUMBOX BLUR.png";
        
        slide5=document.getElementById("slideImage5");
        slide5.src="../../assets/image/OUR PRODUCTS (MOBILE)/FRESHBOX BLUR.png";
    
    
      if(document.getElementById("slide1").parentElement.classList.contains('slick-center')){
        slideText=document.getElementById("sliderContent1");
    
        slideImage=document.getElementById("slideImage1");
        slideImage.src="../../assets/image/OUR PRODUCTS (MOBILE)/EXPRESS.png";
      }
      else if(document.getElementById("slide2").parentElement.classList.contains( 'slick-center')){
        slideText=document.getElementById("sliderContent2");
    
        slideImage=document.getElementById("slideImage2");
        slideImage.src="../../assets/image/OUR PRODUCTS (MOBILE)/VALUEPACK.png";
      }
      else if(document.getElementById("slide3").parentElement.classList.contains( 'slick-center')){
        slideText=document.getElementById("sliderContent3");
    
        slideImage=document.getElementById("slideImage3");
        slideImage.src="../../assets/image/OUR PRODUCTS (MOBILE)/PREMIUM.png";
      }
      else if(document.getElementById("slide4").parentElement.classList.contains( 'slick-center')){
        slideText=document.getElementById("sliderContent4");
    
        slideImage=document.getElementById("slideImage4");
        slideImage.src="../../assets/image/OUR PRODUCTS (MOBILE)/PREMIUMBOX.png";
      }
      else if(document.getElementById("slide5").parentElement.classList.contains( 'slick-center')){
        slideText=document.getElementById("sliderContent5");
    
        slideImage=document.getElementById("slideImage5");
        slideImage.src="../../assets/image/OUR PRODUCTS (MOBILE)/FRESHBOX.png";
      }
    
      let sliderContent=document.getElementById("sliderContent");
      var otherSlide;
    
      for(let i=0;i<5;i++){
        otherSlide=sliderContent.children[i] as HTMLElement;
        otherSlide.style.display="none";
        
      }
      slideText.style.display="block";
        }

    over(number){
        this.hoverImage=document.getElementById("hoverImage");
        switch(number){
            case 1:
                this.hoverImage.src="../../assets/image/HL prepare/part3ExtraImage1.png";
                break;
            case 2:
                this.hoverImage.src="../../assets/image/HL prepare/part3ExtraImage2.png";
                break;
            case 3:
                this.hoverImage.src="../../assets/image/HL prepare/part3ExtraImage3.png";
                break;
            case 4:
                this.hoverImage.src="../../assets/image/HL prepare/part3ExtraImage4.png";
                break;
            default:
                break;
        }
    }

    out(){
        this.hoverImage.src="../../assets/image/STARTSHIPPING/STATIC.png";
    }

    changeSlideContent(){
        var center=document.getElementsByClassName("slick-center");
      
        $(center).change(slideChange());
      
        function slideChange(){
          var slideText;
          var slideImage;
          var slide1,slide2,slide3,slide4,slide5;
      
          slide1=document.getElementById("slideImage1");
          slide1.src="../../assets/image/OUR PRODUCTS (MOBILE)/EXPRESS BLUR.png";
      
          slide2=document.getElementById("slideImage2");
          slide2.src="../../assets/image/OUR PRODUCTS (MOBILE)/VALUEPACK BLUR.png";
          
          slide3=document.getElementById("slideImage3");
          slide3.src="../../assets/image/OUR PRODUCTS (MOBILE)/PREMIUM BLUR.png";
          
          slide4=document.getElementById("slideImage4");
          slide4.src="../../assets/image/OUR PRODUCTS (MOBILE)/PREMIUMBOX BLUR.png";
          
          slide5=document.getElementById("slideImage5");
          slide5.src="../../assets/image/OUR PRODUCTS (MOBILE)/FRESHBOX BLUR.png";
      
      
        if(document.getElementById("slide1").parentElement.classList.contains('slick-center')){
          slideText=document.getElementById("sliderContent1");
      
          slideImage=document.getElementById("slideImage1");
          slideImage.src="../../assets/image/OUR PRODUCTS (MOBILE)/EXPRESS.png";
        }
        else if(document.getElementById("slide2").parentElement.classList.contains( 'slick-center')){
          slideText=document.getElementById("sliderContent2");
      
          slideImage=document.getElementById("slideImage2");
          slideImage.src="../../assets/image/OUR PRODUCTS (MOBILE)/VALUEPACK.png";
        }
        else if(document.getElementById("slide3").parentElement.classList.contains( 'slick-center')){
          slideText=document.getElementById("sliderContent3");
      
          slideImage=document.getElementById("slideImage3");
          slideImage.src="../../assets/image/OUR PRODUCTS (MOBILE)/PREMIUM.png";
        }
        else if(document.getElementById("slide4").parentElement.classList.contains( 'slick-center')){
          slideText=document.getElementById("sliderContent4");
      
          slideImage=document.getElementById("slideImage4");
          slideImage.src="../../assets/image/OUR PRODUCTS (MOBILE)/PREMIUMBOX.png";
        }
        else if(document.getElementById("slide5").parentElement.classList.contains( 'slick-center')){
          slideText=document.getElementById("sliderContent5");
      
          slideImage=document.getElementById("slideImage5");
          slideImage.src="../../assets/image/OUR PRODUCTS (MOBILE)/FRESHBOX.png";
        }
      
      
        let sliderContent=document.getElementById("sliderContent");
        var otherSlide;
      
        for(let i=0;i<5;i++){
          otherSlide=sliderContent.children[i] as HTMLElement;
          otherSlide.style.display="none";
          
        }
        slideText.style.display="block";
          }
      
      }
    
}


